import { render, staticRenderFns } from "./NsProductDetailBase.vue?vue&type=template&id=b283e188&scoped=true&"
import script from "./NsProductDetailBase.vue?vue&type=script&lang=js&"
export * from "./NsProductDetailBase.vue?vue&type=script&lang=js&"
import style0 from "./NsProductDetailBase.vue?vue&type=style&index=0&id=b283e188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b283e188",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/Button.vue').default})
